import router from '@/router';
import { ServicesContainer } from '@/services';
import { ProductViewEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, ShoppingCart, WebPageDetails } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobePageLoadEvent } from './adobe-page-load';

export class AdobeProductViewEvent extends AdobePageLoadEvent {
  event = AnalyticsEventType.ProductViews;
  shoppingCart?: ShoppingCart;

  constructor(event: ProductViewEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    const groupName = router.currentRoute.params.groupName;

    Object.assign(this.web.webPageDetails, this.createMealBuilderDetails(groupName));
    this.commerce.productViews = { value: 1 };

    if (groupName == 'lifestyle-bowl' || groupName == `kid's-meal`) {
      this.commerce.menuListViews = { value: 1 };
    }

    if (store.state.adobe.isMakeItMyOwn) {
      this.shoppingCart = { pceMakeItMyOwn: { value: 1 }};
      services.utils.setIsMakeItMyOwn(false);
    }
  }

  createMealBuilderDetails(groupName: string): WebPageDetails {

    const siteSection = 'order';
    const subSection1 = router.currentRoute.name;
    const subSection2 =
      groupName == `kid's-quesadilla` || groupName == `kid's-build-your-own`
        ? `kid's-meal`
        : '';
    const page = groupName;

    let details = {
      pageType: router.currentRoute.name,
      siteSection,
      subSection1,
      subSection2,
      page,
      name: `${siteSection}:${subSection1}:${subSection2 && subSection2 + ':'}${page}`
    } as WebPageDetails;

    return details;
  }
}
